<div class="card-box mt-3 previa-card">
  <button
    type="button"
    class="previa-cabecalho"
    [attr.aria-expanded]="aberta"
    [title]="aberta ? 'Fechar a prévia da página' : 'Ver como a página fica no portal'"
    (click)="alternarPrevia()">
    <span class="previa-cabecalho-icone" aria-hidden="true">
      <i-lucide name="monitor-play" size="18"></i-lucide>
    </span>

    <span class="previa-cabecalho-texto">
      <span class="previa-secao-nome">Prévia da página</span>
      <span class="previa-secao-descricao">
        Veja como a página fica no portal e ajuste a imagem publicada.
      </span>
    </span>

    <span class="previa-cabecalho-situacao" [class.oculta]="!emEdicao.exibirImagem">
      {{ emEdicao.exibirImagem ? 'Imagem ativa' : 'Imagem oculta' }}
    </span>

    <i-lucide
      [name]="aberta ? 'chevron-up' : 'chevron-down'"
      size="18"
      class="previa-cabecalho-seta"></i-lucide>
  </button>

  <div class="previa-corpo" *ngIf="aberta">
    <input
      #arquivoImagem
      hidden
      type="file"
      accept="image/png,image/jpeg"
      (change)="aoSelecionarArquivo($event)">

    <div class="d-flex justify-content-end mb-3">
      <div class="previa-formatos" role="group" aria-label="Formato da prévia">
        <button
          type="button"
          class="previa-formato"
          [class.ativa]="formatoPrevia === 'desktop'"
          title="Ver a prévia em tela larga"
          (click)="definirFormatoPrevia('desktop')">
          <i-lucide name="monitor" size="15"></i-lucide>
          Desktop
        </button>

        <button
          type="button"
          class="previa-formato"
          [class.ativa]="formatoPrevia === 'mobile'"
          title="Ver a prévia em tela estreita"
          (click)="definirFormatoPrevia('mobile')">
          <i-lucide name="smartphone" size="15"></i-lucide>
          Mobile
        </button>
      </div>
    </div>

    <div class="previa-moldura" [class.mobile]="formatoPrevia === 'mobile'">
      <!-- Réplica da página do portal (pages-perguntas-politica-canais) -->
      <section class="previa-portal portal-tema" [attr.data-tema]="temaPortal">
        <div class="previa-portal-topo">
          <h2 class="previa-portal-titulo">
            {{ titulo }}
            <span class="previa-portal-enfeites" aria-hidden="true">
              <span class="previa-portal-ponto"></span>
              <span class="previa-portal-traco"></span>
              <span class="previa-portal-ponto"></span>
            </span>
          </h2>

          <p class="previa-portal-subtitulo" *ngIf="subtitulo">{{ subtitulo }}</p>
        </div>

        <div class="previa-portal-divisao" [class.sem-imagem]="!comImagem">
          <!-- Campo da imagem: ocultar e substituir ficam sobre a própria imagem -->
          <figure class="previa-portal-figura" *ngIf="comImagem">
            <img
              class="previa-portal-ilustracao"
              [src]="emEdicao.imagem"
              alt="Ilustração publicada na página">

            <figcaption class="previa-portal-acoes">
              <button
                type="button"
                class="previa-acao"
                title="Ocultar esta imagem na página do portal"
                (click)="alternarExibirImagem()">
                <i-lucide name="eye-off" size="15"></i-lucide>
                Ocultar
              </button>

              <button
                type="button"
                class="previa-acao"
                title="Enviar outra imagem para esta página"
                (click)="arquivoImagem.click()">
                <i-lucide name="image" size="15"></i-lucide>
                Substituir
              </button>
            </figcaption>
          </figure>

          <div class="previa-portal-painel">
            <div class="previa-portal-busca">
              <span class="previa-portal-busca-campo">{{ rotuloBusca }}</span>
              <i-lucide name="search" size="16" class="previa-portal-busca-icone"></i-lucide>
            </div>

            <ul class="previa-portal-lista">
              <li class="previa-portal-item" *ngFor="let secao of secoes; trackBy: trackBySecao">
                <span class="previa-portal-item-icone" aria-hidden="true">
                  <i-lucide [name]="secao.icone" size="18"></i-lucide>
                </span>

                <span class="previa-portal-item-titulo">{{ secao.titulo }}</span>

                <i-lucide name="chevron-down" size="16" class="previa-portal-item-seta"></i-lucide>
              </li>

              <li class="previa-portal-vazio" *ngIf="secoes.length === 0">
                Nenhum conteúdo publicado no momento.
              </li>
            </ul>
          </div>
        </div>
      </section>
    </div>

    <!-- Fora da página só quando a imagem não aparece nela: guardada ou ainda não enviada -->
    <div class="previa-campo" *ngIf="!comImagem && temImagem">
      <img class="previa-campo-miniatura" [src]="emEdicao.imagem" alt="Imagem guardada da página">

      <div class="previa-campo-texto">
        <span class="previa-campo-nome">{{ emEdicao.nomeImagem }}</span>
        <span class="previa-campo-situacao">
          {{ emEdicao.exibirImagem
            ? 'Guardada: em tela estreita o portal não exibe a imagem.'
            : 'Oculta no portal. O arquivo continua guardado.' }}
        </span>
      </div>

      <div class="d-flex flex-wrap gap-2">
        <button
          type="button"
          class="previa-acao"
          *ngIf="!emEdicao.exibirImagem"
          title="Exibir esta imagem na página do portal"
          (click)="alternarExibirImagem()">
          <i-lucide name="eye" size="15"></i-lucide>
          Exibir
        </button>

        <button
          type="button"
          class="previa-acao"
          *ngIf="emEdicao.exibirImagem"
          title="Ocultar esta imagem na página do portal"
          (click)="alternarExibirImagem()">
          <i-lucide name="eye-off" size="15"></i-lucide>
          Ocultar
        </button>

        <button
          type="button"
          class="previa-acao"
          title="Enviar outra imagem para esta página"
          (click)="arquivoImagem.click()">
          <i-lucide name="image" size="15"></i-lucide>
          Substituir
        </button>
      </div>
    </div>

    <button
      type="button"
      class="wizard-dropzone mt-3"
      *ngIf="!temImagem"
      [class.arrastando]="arrastando"
      title="Selecionar a imagem da página"
      (click)="arquivoImagem.click()"
      (dragover)="aoArrastar($event)"
      (dragleave)="aoSairDoArraste($event)"
      (drop)="aoSoltar($event)">
      <i-lucide name="cloud-upload" size="26" class="wizard-dropzone-icone"></i-lucide>

      <span class="wizard-dropzone-titulo">Arraste a imagem ou clique para selecionar</span>

      <span class="wizard-dropzone-dica">
        PNG ou JPG · {{ limites.largura }} × {{ limites.altura }} px · até {{ limites.tamanhoMaximoMb }}MB
      </span>

      <span class="wizard-dropzone-dica">
        Fora do padrão? O recorte abre automaticamente em {{ limites.largura }} × {{ limites.altura }} px.
      </span>
    </button>

    <div class="d-flex flex-wrap justify-content-between align-items-center gap-2 mt-3">
      <p class="previa-nota mb-0">
        <i-lucide name="info" size="14"></i-lucide>
        <ng-container *ngIf="formatoPrevia === 'mobile'">
          Em tela estreita o portal sempre esconde a imagem e mostra só o conteúdo.
        </ng-container>
        <ng-container *ngIf="formatoPrevia === 'desktop' && comImagem">
          A imagem ocupa a coluna da esquerda. Em tela estreita o portal a esconde.
        </ng-container>
        <ng-container *ngIf="formatoPrevia === 'desktop' && temImagem && !emEdicao.exibirImagem">
          Oculta, a imagem sai da página e o conteúdo ocupa a largura inteira.
        </ng-container>
        <ng-container *ngIf="formatoPrevia === 'desktop' && !temImagem">
          Nenhuma imagem enviada: o conteúdo ocupa a largura inteira da página.
        </ng-container>
      </p>

      <button
        type="button"
        class="btn btn-sm btn-add text-nowrap"
        [disabled]="!podeSalvar"
        [title]="podeSalvar ? 'Salvar a imagem da página' : 'Nenhuma alteração para salvar'"
        (click)="salvar()">
        <i-lucide name="check" size="16"></i-lucide>
        Salvar
      </button>
    </div>
  </div>
</div>
